module.exports = __webpack_public_path__ + "static/media/5e349c95d8d0c2121b0d4ecd_Fast-LogoWhite.e14816b9.svg";